export const speaker = {
    maleMp: {
        frames: {
            full: [
                [0, 0, 171, 372, 0],
                [0, 0, 171, 372, 0],
                [0, 0, 171, 372, 0],
                [0, 0, 171, 372, 0],
                [0, 0, 171, 372, 0],
                [0, 0, 171, 372, 0],
                [171, 0, 168, 378, 0],
                [339, 0, 167, 385, 0],
                [506, 0, 169, 391, 0],
                [675, 0, 169, 399, 0],
                [844, 0, 166, 405, 0],
                [0, 405, 156, 412, 0],
                [156, 405, 138, 419, 0],
                [294, 405, 121, 424, 0],
                [415, 405, 125, 432, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [540, 405, 138, 439, 0],
                [415, 405, 125, 432, 0],
                [294, 405, 121, 424, 0],
                [156, 405, 138, 419, 0],
                [0, 405, 156, 412, 0],
                [844, 0, 166, 405, 0],
                [675, 0, 169, 399, 0],
                [506, 0, 169, 391, 0],
                [339, 0, 167, 385, 0],
                [171, 0, 168, 378, 0],
                [0, 0, 171, 372, 0],
            ],
            half: [
                // x, y, width, height, imageIndex*, regX*, regY*
                [0, 0, 171, 180, 0],
                [0, 0, 171, 180, 0],
                [0, 0, 171, 180, 0],
                [0, 0, 171, 180, 0],
                [0, 0, 171, 180, 0],
                [0, 0, 171, 180, 0],
                [171, 0, 168, 180, 0],
                [339, 0, 167, 180, 0],
                [506, 0, 169, 180, 0],
                [675, 0, 169, 180, 0],
                [844, 0, 166, 180, 0],
                [0, 405, 156, 180, 0],
                [156, 405, 138, 180, 0],
                [294, 405, 121, 180, 0],
                [415, 405, 125, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [540, 405, 138, 180, 0],
                [415, 405, 125, 180, 0],
                [294, 405, 121, 180, 0],
                [156, 405, 138, 180, 0],
                [0, 405, 156, 180, 0],
                [844, 0, 166, 180, 0],
                [675, 0, 169, 180, 0],
                [506, 0, 169, 180, 0],
                [339, 0, 167, 180, 0],
                [171, 0, 168, 180, 0],
                [0, 0, 171, 180, 0],
            ],
        },
        animations: {
            //[startFrame, endFrame, nextAnimation, playbackSpeed]
            stand: [0, 21, 'stood', 1],
            stood: [22, 23, 'stood', 1],
            sit: [24, 39, 'sat', 1],
            sat: [0, 1, 'sat', 1],
        },
    },
    femaleMp: {
        frames: {
            full: [
                [0, 0, 193, 360, 0],
                [0, 0, 193, 360, 0],
                [0, 0, 193, 360, 0],
                [0, 0, 193, 360, 0],
                [0, 0, 193, 360, 0],
                [0, 0, 193, 360, 0],
                [193, 0, 182, 368, 0],
                [0, 368, 173, 375, 0],
                [173, 368, 163, 383, 0],
                [336, 368, 165, 390, 0],
                [0, 758, 168, 398, 0],
                [168, 758, 167, 406, 0],
                [335, 758, 159, 414, 0],
                [0, 1172, 138, 421, 0],
                [138, 1172, 113, 430, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [138, 1172, 113, 430, 0],
                [0, 1172, 138, 421, 0],
                [335, 758, 159, 414, 0],
                [168, 758, 167, 406, 0],
                [0, 758, 168, 398, 0],
                [336, 368, 165, 390, 0],
                [173, 368, 163, 383, 0],
                [0, 368, 173, 375, 0],
                [193, 0, 182, 368, 0],
                [0, 1609, 193, 360, 0],
            ],
            half: [
                [0, 0, 193, 360, 0],
                [0, 0, 193, 360, 0],
                [0, 0, 193, 360, 0],
                [0, 0, 193, 360, 0],
                [0, 0, 193, 360, 0],
                [0, 0, 193, 360, 0],
                [193, 0, 182, 368, 0],
                [0, 368, 173, 375, 0],
                [173, 368, 163, 383, 0],
                [336, 368, 165, 390, 0],
                [0, 758, 168, 398, 0],
                [168, 758, 167, 406, 0],
                [335, 758, 159, 414, 0],
                [0, 1172, 138, 421, 0],
                [138, 1172, 113, 430, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [251, 1172, 112, 437, 0],
                [138, 1172, 113, 430, 0],
                [0, 1172, 138, 421, 0],
                [335, 758, 159, 414, 0],
                [168, 758, 167, 406, 0],
                [0, 758, 168, 398, 0],
                [336, 368, 165, 390, 0],
                [173, 368, 163, 383, 0],
                [0, 368, 173, 375, 0],
                [193, 0, 182, 368, 0],
                [0, 1609, 193, 360, 0],
            ],
        },
        animations: {
            //[startFrame, endFrame, nextAnimation, playbackSpeed]
            stand: [0, 25, 'stood', 1],
            stood: [26, 27, 'stood', 1],
            sit: [28, 49, 'sat', 1],
            sat: [0, 1, 'sat', 1],
        },
    },
    body: {
        tap: {
            frames: [
                [0, 0, 849, 323, 0],
                [849, 0, 849, 323, 0],
                [0, 323, 849, 323, 0],
                [849, 323, 849, 323, 0],
                [0, 646, 849, 323, 0],
                [849, 646, 849, 323, 0],
                [0, 969, 849, 323, 0],
                [849, 969, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [849, 1292, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [849, 1615, 849, 323, 0],
                [0, 1938, 849, 323, 0],
                [849, 1938, 849, 323, 0],
                [0, 2261, 849, 323, 0],
            ],
            animations: {
                tap: [0, 14, 'tap', 1],
            },
        },
        forward: {
            frames: [
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 323, 849, 323, 0],
                [0, 646, 849, 323, 0],
                [0, 969, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
            ],
            animations: {
                forward: [0, 24, false, 1],
            },
        },
        left: {
            frames: [
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 323, 849, 323, 0],
                [0, 646, 849, 323, 0],
                [0, 969, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
                [0, 1615, 849, 323, 0],
            ],
            animations: {
                left: [0, 16, false, 1],
            },
        },
        right: {
            frames: [
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 0, 849, 323, 0],
                [0, 323, 849, 323, 0],
                [0, 646, 849, 323, 0],
                [0, 969, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
                [0, 1292, 849, 323, 0],
            ],
            animations: {
                right: [0, 24, false, 1],
            },
        },
    },
    head: {
        forward: {
            frames: [
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [562, 0, 281, 285, 0],
                [0, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [0, 285, 281, 285, 0],
                [562, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [281, 570, 281, 285, 0],
                [562, 570, 281, 285, 0],
                [0, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [0, 855, 281, 285, 0],
                [562, 570, 281, 285, 0],
                [281, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [281, 1140, 281, 285, 0],
                [562, 1140, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [562, 1140, 281, 285, 0],
                [281, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
            ],
            animations: {
                //[startFrame, endFrame, nextAnimation, playbackSpeed]
                front: [0, 399, 'front', 1],
            },
        },
        left: {
            frames: [
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [562, 0, 281, 285, 0],
                [0, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [0, 285, 281, 285, 0],
                [562, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [281, 570, 281, 285, 0],
                [562, 570, 281, 285, 0],
                [0, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [0, 855, 281, 285, 0],
                [562, 570, 281, 285, 0],
                [281, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
            ],
            animations: {
                left: [0, 399, 'left', 1],
            },
        },

        leftUp: {
            frames: [
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [562, 0, 281, 285, 0],
                [0, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [0, 285, 281, 285, 0],
                [562, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [281, 570, 281, 285, 0],
                [562, 570, 281, 285, 0],
                [0, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [0, 855, 281, 285, 0],
                [562, 570, 281, 285, 0],
                [281, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [281, 1140, 281, 285, 0],
                [562, 1140, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [562, 1140, 281, 285, 0],
                [281, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
            ],
            animations: {
                leftUp: [0, 400, 'leftUp', 1],
            },
        },

        right: {
            frames: [
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [562, 0, 281, 285, 0],
                [0, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [0, 285, 281, 285, 0],
                [562, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [281, 570, 281, 285, 0],
                [562, 570, 281, 285, 0],
                [0, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [0, 855, 281, 285, 0],
                [562, 570, 281, 285, 0],
                [281, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
            ],
            animations: {
                right: [0, 401, 'right', 1],
            },
        },
        rightUp: {
            frames: [
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [0, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [562, 0, 281, 285, 0],
                [0, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [281, 285, 281, 285, 0],
                [0, 285, 281, 285, 0],
                [562, 0, 281, 285, 0],
                [281, 0, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [562, 285, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [281, 570, 281, 285, 0],
                [562, 570, 281, 285, 0],
                [0, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [281, 855, 281, 285, 0],
                [0, 855, 281, 285, 0],
                [562, 570, 281, 285, 0],
                [281, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [0, 570, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [281, 1140, 281, 285, 0],
                [562, 1140, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [0, 1425, 281, 285, 0],
                [562, 1140, 281, 285, 0],
                [281, 1140, 281, 285, 0],
                [0, 1140, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
                [562, 855, 281, 285, 0],
            ],
            animations: {
                rightUp: [0, 400, 'rightUp', 1],
            },
        },
    },
};
